import { endPoint } from '@/utils';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/redux/store';
import { setLoginPopup } from '@/redux/actions/common.action';
import { setUserData } from '@/redux/actions/user.action';
import * as yup from 'yup';
import useFetch from '@/hooks/useFetch.hook';

const useUserInfo = () => {
  const dispatch = useDispatch<AppDispatch>();
  const initialValues = { email: '', name: '' };
  const userInfoValidationSchema = yup.object().shape({
    email: yup.string().email(),
    name: yup.string().required(),
  });
  const { fetchData, loading, error } = useFetch();
  const onSubmit = async (values: any) => {
    const userData = {
      email: values?.email?.trim() || null,
      name: values.name,
    };
    const res: any = await fetchData({
      url: endPoint.EDIT_USER,
      method: 'POST',
      body: userData,
    });

    if (res && res?.profileComplete) {
      dispatch(setUserData(res));
      dispatch(setLoginPopup(false));
    }
  };
  return {
    onSubmit,
    loading,
    error,
    userInfoValidationSchema,
    initialValues,
  };
};

export default useUserInfo;
